import { PureComponent } from "react";

import { Helmet } from "react-helmet";
import { Route } from "react-router-dom";

import { Provider as ReduxProvider } from "react-redux";

import { ScrollContext } from "react-router-scroll-4";

import { fetchCustomEmojis } from "flavours/glitch/actions/custom_emojis";
import { checkDeprecatedLocalSettings } from "flavours/glitch/actions/local_settings";
import { initSettingsSync } from "flavours/glitch/actions/settings_sync";
import { loadSiteConfig } from "flavours/glitch/actions/site_config";
import { hydrateStore } from "flavours/glitch/actions/store";
import { connectUserStream } from "flavours/glitch/actions/streaming";
import ErrorBoundary from "flavours/glitch/components/error_boundary";
import { IdentityContext } from "flavours/glitch/identity_context";
import { Router } from "flavours/glitch/components/router";
import UI from "flavours/glitch/features/ui";
import initialState, { title as siteTitle } from "flavours/glitch/initial_state";
import { IntlProvider } from "flavours/glitch/locales";
import { store } from "flavours/glitch/store";

import { ThemeComponent } from "./theme_component";

const title = process.env.NODE_ENV === "production" ? siteTitle : `${siteTitle} (Dev)`;

const hydrateAction = hydrateStore(initialState);
store.dispatch(hydrateAction);

// runtime config (public/config.json)
store.dispatch(loadSiteConfig());

// check for deprecated local settings
store.dispatch(checkDeprecatedLocalSettings());

if (initialState.meta.me) {
  store.dispatch(fetchCustomEmojis());
  store.dispatch(initSettingsSync());
}

const createIdentityContext = state => ({
  signedIn: !!state.meta.me,
  accountId: state.meta.me,
  disabledAccountId: state.meta.disabled_account_id,
  accessToken: state.meta.access_token,
  permissions: state.role ? state.role.permissions : 0,
});

export default class Mastodon extends PureComponent {

  identity = createIdentityContext(initialState);

  componentDidMount() {
    if (this.identity.signedIn) {
      this.disconnect = store.dispatch(connectUserStream());
    }
  }

  componentWillUnmount () {
    if (this.disconnect) {
      this.disconnect();
      this.disconnect = null;
    }
  }

  shouldUpdateScroll (_, { location }) {
    return !(location.state?.mastodonModalKey);
  }

  render () {
    return (
      <IdentityContext.Provider value={this.identity}>
        <IntlProvider>
          <ReduxProvider store={store}>
            <ThemeComponent>
              <ErrorBoundary>
                <Router>
                  <ScrollContext shouldUpdateScroll={this.shouldUpdateScroll}>
                    <Route path='/' component={UI} />
                  </ScrollContext>
                </Router>

                <Helmet defaultTitle={title} titleTemplate={`%s - ${title}`} />
              </ErrorBoundary>
            </ThemeComponent>
          </ReduxProvider>
        </IntlProvider>
      </IdentityContext.Provider>
    );
  }

}
